import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bayDetails: [],
};

export const planoSlice = createSlice({
  name: "plano",
  initialState,
  reducers: {
    setBayDetails(state, action) {
      state.bayDetails = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBayDetails } = planoSlice.actions;

export default planoSlice.reducer;
